import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, mergeProps as _mergeProps, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a8f04f4f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tp-hero-area lightblue-bg tp-hero-2-bg" }
const _hoisted_2 = { class: "container custom-container" }
const _hoisted_3 = { class: "tp-hero-2-wrap" }
const _hoisted_4 = { class: "row align-items-end" }
const _hoisted_5 = { class: "col-xxl-5 col-xl-6 col-lg-7 col-md-12" }
const _hoisted_6 = { class: "tp-hero-2-content" }
const _hoisted_7 = {
  class: "tp-hero-2-subtitle wow fadeInUp",
  "data-wow-delay": ".3s"
}
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = {
  class: "tp-hero-2-btn wow fadeInUp",
  "data-wow-delay": ".9s"
}
const _hoisted_13 = ["href"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "14",
    height: "11",
    viewBox: "0 0 14 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M8.71533 1L13 5.28471L8.71533 9.56941",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-miterlimit": "10",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M1 5.28473H12.88",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-miterlimit": "10",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1 /* HOISTED */))
const _hoisted_15 = {
  key: 0,
  class: "offset-xxl-4 col-xxl-3 offset-xl-2 col-xl-4 col-lg-5 col-md-6"
}
const _hoisted_16 = {
  class: "tp-hero-2-course p-relative wow fadeInUp",
  "data-wow-delay": ".5s"
}
const _hoisted_17 = { class: "tp-hero-2-thumb" }
const _hoisted_18 = ["src"]
const _hoisted_19 = /*#__PURE__*/_createStaticVNode("<div class=\"tp-hero-2-shape\" data-v-a8f04f4f><div class=\"tp-hero-2-shape-1\" data-v-a8f04f4f><span data-v-a8f04f4f><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"846\" height=\"579\" viewBox=\"0 0 846 579\" fill=\"none\" data-v-a8f04f4f><path class=\"line-2\" d=\"M212.745 593.864C358.949 649.758 822.546 792.326 466.431 560.525C110.316 328.724 477.436 405.184 743.017 461.029C1008.6 516.874 193.087 -40.2421 69.0387 93.5502C-55.0097 227.343 493.91 431.765 484.946 51.9085\" stroke=\"url(#paint0_linear_311_1041)\" stroke-width=\"100\" stroke-linecap=\"square\" data-v-a8f04f4f></path><defs data-v-a8f04f4f><linearGradient id=\"paint0_linear_311_1041\" x1=\"769.255\" y1=\"703.159\" x2=\"-110.567\" y2=\"48.8101\" gradientUnits=\"userSpaceOnUse\" data-v-a8f04f4f></linearGradient></defs></svg></span></div><div class=\"tp-hero-2-shape-2\" data-v-a8f04f4f><img src=\"/assets/lms_website/website-assets/img/hero/hero-2-shape-2.png\" alt=\"\" data-v-a8f04f4f></div><div class=\"tp-hero-2-shape-3\" data-v-a8f04f4f><img src=\"/assets/lms_website/website-assets/img/hero/hero-2-shape-3.png\" alt=\"\" data-v-a8f04f4f></div><div class=\"tp-hero-2-shape-4\" data-v-a8f04f4f><img src=\"/assets/lms_website/website-assets/img/hero/hero-2-shape-4.png\" alt=\"\" data-v-a8f04f4f></div></div>", 1)
const _hoisted_20 = { class: "home-header-logos" }
const _hoisted_21 = { class: "container" }
const _hoisted_22 = { class: "d-flex align-items-center justify-content-center" }
const _hoisted_23 = ["tooltip"]
const _hoisted_24 = ["src", "alt"]
const _hoisted_25 = { class: "category-area mb-80 mt-95" }
const _hoisted_26 = { class: "container" }
const _hoisted_27 = { class: "row justify-content-center" }
const _hoisted_28 = { class: "col-xl-8 col-lg-10" }
const _hoisted_29 = {
  class: "tp-section mb-40 text-center wow fadeInUp",
  "data-wow-delay": ".4s"
}
const _hoisted_30 = { class: "tp-section-3-subtitle" }
const _hoisted_31 = ["innerHTML"]
const _hoisted_32 = ["innerHTML"]
const _hoisted_33 = {
  key: 0,
  class: "row"
}
const _hoisted_34 = { class: "col-lg-3 col-md-4 col-sm-6" }
const _hoisted_35 = /*#__PURE__*/_createStaticVNode("<div class=\"tp-category-item mb-25 wow fadeInUp placeholder-glow\" data-wow-delay=\".3s\" data-v-a8f04f4f><div class=\"tp-category-icon\" data-v-a8f04f4f><div class=\"placeholder rounded\" style=\"width:42px;height:42px;\" data-v-a8f04f4f></div></div><div class=\"tp-category-content\" data-v-a8f04f4f><div class=\"placeholder rounded\" style=\"width:100px;height:22px;\" data-v-a8f04f4f></div><span data-v-a8f04f4f><div class=\"placeholder rounded\" style=\"width:160px;height:15px;\" data-v-a8f04f4f></div></span></div></div>", 1)
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = {
  key: 1,
  class: "row"
}
const _hoisted_38 = { class: "tp-category-icon" }
const _hoisted_39 = ["src"]
const _hoisted_40 = { class: "tp-category-content" }
const _hoisted_41 = { class: "tp-category-title" }
const _hoisted_42 = { class: "row justify-content-center" }
const _hoisted_43 = { class: "col-xl-6 col-lg-8" }
const _hoisted_44 = {
  class: "tp-category-banner d-flex align-items-center justify-content-between tp-category-banner-bg mt-35",
  "data-background": "/assets/lms_website/website-assets/img/bg/category-bg.jpg"
}
const _hoisted_45 = { class: "tp-category-banner-content d-flex align-items-center" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tp-category-banner-shape" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/assets/lms_website/website-assets/img/shape/category-2-shape-1.png",
    alt: ""
  })
], -1 /* HOISTED */))
const _hoisted_47 = { class: "tp-category-banner-text" }
const _hoisted_48 = { class: "tp-category-banner-title" }
const _hoisted_49 = { class: "tp-category-banner-btn" }
const _hoisted_50 = { class: "tp-btn-2" }
const _hoisted_51 = {
  class: "funfact-area tp-funfact-bg",
  "data-background": "/assets/lms_website/website-assets/img/bg/funfact-2-bg-1.jpg"
}
const _hoisted_52 = { class: "container" }
const _hoisted_53 = { class: "row" }
const _hoisted_54 = { class: "col-lg-3 col-sm-6" }
const _hoisted_55 = { class: "tp-funfact-item d-flex align-items-center" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tp-funfact-icon" }, [
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "/assets/lms_website/website-assets/img/icon/funfact/funfact-2-icon-1.svg",
      alt: "icon"
    })
  ])
], -1 /* HOISTED */))
const _hoisted_57 = { class: "tp-funfact-content" }
const _hoisted_58 = { class: "tp-funfact-title" }
const _hoisted_59 = { class: "col-lg-3 col-sm-6" }
const _hoisted_60 = { class: "tp-funfact-item tp-funfact-item-2 d-flex align-items-center" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tp-funfact-icon" }, [
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "/assets/lms_website/website-assets/img/icon/funfact/funfact-2-icon-2.svg",
      alt: "icon"
    })
  ])
], -1 /* HOISTED */))
const _hoisted_62 = { class: "tp-funfact-content" }
const _hoisted_63 = { class: "tp-funfact-title" }
const _hoisted_64 = { class: "col-lg-3 col-sm-6" }
const _hoisted_65 = { class: "tp-funfact-item tp-funfact-item-3 d-flex align-items-center" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tp-funfact-icon" }, [
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "/assets/lms_website/website-assets/img/icon/funfact/funfact-2-icon-3.svg",
      alt: "icon"
    })
  ])
], -1 /* HOISTED */))
const _hoisted_67 = { class: "tp-funfact-content" }
const _hoisted_68 = { class: "tp-funfact-title" }
const _hoisted_69 = { class: "col-lg-3 col-sm-6" }
const _hoisted_70 = { class: "tp-funfact-item d-flex align-items-center justify-content-lg-end" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tp-funfact-icon" }, [
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "/assets/lms_website/website-assets/img/icon/funfact/funfact-2-icon-4.svg",
      alt: "icon"
    })
  ])
], -1 /* HOISTED */))
const _hoisted_72 = { class: "tp-funfact-content" }
const _hoisted_73 = { class: "tp-funfact-title" }
const _hoisted_74 = { class: "course-area tp-course-wrapper mt-100 mb-100" }
const _hoisted_75 = { class: "container" }
const _hoisted_76 = { class: "row align-items-end" }
const _hoisted_77 = { class: "col-lg-6 col-md-8" }
const _hoisted_78 = { class: "tp-section mb-40" }
const _hoisted_79 = { class: "tp-section-3-subtitle" }
const _hoisted_80 = ["innerHTML"]
const _hoisted_81 = ["innerHTML"]
const _hoisted_82 = { class: "col-lg-6 col-md-4" }
const _hoisted_83 = { class: "tp-team-2-arrow d-flex align-items-center justify-content-md-end mb-55" }
const _hoisted_84 = { class: "tp-home-courses-prev" }
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "7",
  height: "12",
  viewBox: "0 0 7 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M6 11L1 6L6 1",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1 /* HOISTED */))
const _hoisted_86 = [
  _hoisted_85
]
const _hoisted_87 = { class: "tp-home-courses-next" }
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "7",
  height: "12",
  viewBox: "0 0 7 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1 11L6 6L1 1",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1 /* HOISTED */))
const _hoisted_89 = [
  _hoisted_88
]
const _hoisted_90 = { class: "row" }
const _hoisted_91 = { class: "col-lg-4 col-md-6" }
const _hoisted_92 = /*#__PURE__*/_createStaticVNode("<div class=\"tp-course-item p-relative fix mb-30 placeholder-glow\" data-v-a8f04f4f><div class=\"tp-course-teacher mb-15\" data-v-a8f04f4f><div class=\"d-flex align-items-center gap-1\" data-v-a8f04f4f><span class=\"placeholder d-inline-block rounded-circle\" style=\"width:30px;height:30px;\" data-v-a8f04f4f></span><span class=\"placeholder d-inline-block rounded\" style=\"width:80px;height:10px;\" data-v-a8f04f4f></span></div></div><div class=\"tp-course-thumb\" data-v-a8f04f4f><span class=\"placeholder d-block rounded\" style=\"height:200px;\" data-v-a8f04f4f></span></div><div class=\"tp-course-content\" data-v-a8f04f4f><div class=\"d-flex align-items-center gap-1 mb-10\" data-v-a8f04f4f><span class=\"placeholder d-inline-block rounded\" style=\"width:100px;height:25px;\" data-v-a8f04f4f></span></div><div class=\"tp-course-meta\" data-v-a8f04f4f><div class=\"d-flex align-items-center gap-1\" data-v-a8f04f4f><span class=\"placeholder d-inline-block rounded\" style=\"width:80px;height:10px;\" data-v-a8f04f4f></span><span class=\"placeholder d-inline-block rounded\" style=\"width:80px;height:10px;\" data-v-a8f04f4f></span></div></div><span class=\"placeholder d-block rounded mt-4 mb-1\" style=\"width:80%;height:6px;\" data-v-a8f04f4f></span><span class=\"placeholder d-block rounded\" style=\"width:30%;height:6px;\" data-v-a8f04f4f></span></div></div>", 1)
const _hoisted_93 = [
  _hoisted_92
]
const _hoisted_94 = { class: "mt-4 row" }
const _hoisted_95 = { class: "col-lg-4 offset-lg-4 text-center" }
const _hoisted_96 = {
  key: 0,
  class: "live-area lightblue-bg pt-95 pb-140"
}
const _hoisted_97 = { class: "container" }
const _hoisted_98 = { class: "row justify-content-center" }
const _hoisted_99 = { class: "col-xl-8 col-lg-10" }
const _hoisted_100 = { class: "tp-section text-center mb-65" }
const _hoisted_101 = { class: "tp-section-3-subtitle" }
const _hoisted_102 = ["innerHTML"]
const _hoisted_103 = ["innerHTML"]
const _hoisted_104 = { class: "row justify-content-center" }
const _hoisted_105 = { class: "col-xl-10" }
const _hoisted_106 = {
  class: "tp-live-bg wow fadeInUp",
  "data-wow-delay": ".2s"
}
const _hoisted_107 = { class: "row align-items-center" }
const _hoisted_108 = { class: "col-lg-6 col-md-4" }
const _hoisted_109 = { class: "tp-live-thumb p-relative" }
const _hoisted_110 = ["src", "alt"]
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tp-live-thumb-video" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/assets/lms_website/website-assets/img/teacher/live-2-video.png",
    alt: ""
  })
], -1 /* HOISTED */))
const _hoisted_112 = { class: "tp-live-thumb-text" }
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15Z",
    stroke: "white",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M8 3.7998V7.9998L10.8 9.3998",
    stroke: "white",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1 /* HOISTED */))
const _hoisted_114 = { class: "col-lg-6 col-md-8" }
const _hoisted_115 = { class: "tp-live-content" }
const _hoisted_116 = { class: "tp-live-tag" }
const _hoisted_117 = { class: "tp-live-teacher" }
const _hoisted_118 = { class: "tp-live-teacher-info d-flex align-items-center" }
const _hoisted_119 = { class: "tp-live-teacher-thumb" }
const _hoisted_120 = ["src"]
const _hoisted_121 = { class: "tp-live-teacher-text" }
const _hoisted_122 = { class: "tp-live-teacher-title" }
const _hoisted_123 = { class: "tp-live-rating" }
const _hoisted_124 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "/5", -1 /* HOISTED */))
const _hoisted_125 = { class: "tp-live-rating-star" }
const _hoisted_126 = { class: "course-star-rating star-rating-sm m-0 mt-1" }
const _hoisted_127 = /*#__PURE__*/_createStaticVNode("<div class=\"back-stars\" data-v-a8f04f4f><i class=\"fa fa-star\" data-v-a8f04f4f></i><i class=\"fa fa-star\" data-v-a8f04f4f></i><i class=\"fa fa-star\" data-v-a8f04f4f></i><i class=\"fa fa-star\" data-v-a8f04f4f></i><i class=\"fa fa-star\" data-v-a8f04f4f></i></div>", 1)
const _hoisted_128 = /*#__PURE__*/_createStaticVNode("<i class=\"fa fa-star\" data-v-a8f04f4f></i><i class=\"fa fa-star\" data-v-a8f04f4f></i><i class=\"fa fa-star\" data-v-a8f04f4f></i><i class=\"fa fa-star\" data-v-a8f04f4f></i><i class=\"fa fa-star\" data-v-a8f04f4f></i>", 5)
const _hoisted_133 = [
  _hoisted_128
]
const _hoisted_134 = { class: "tp-live-title" }
const _hoisted_135 = { class: "tp-live-total" }
const _hoisted_136 = { class: "tp-live-total-student" }
const _hoisted_137 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/lms_website/website-assets/img/teacher/live-2-teacher-2.png",
  alt: ""
}, null, -1 /* HOISTED */))
const _hoisted_138 = {
  key: 0,
  class: "tp-live-join"
}
const _hoisted_139 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "16",
    height: "14",
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M3.70732 0.75H8.39024C9.65603 0.75 10.333 1.00147 10.7145 1.38301C11.0961 1.76456 11.3476 2.44153 11.3476 3.70732V9.95122C11.3476 11.217 11.0961 11.894 10.7145 12.2755C10.333 12.6571 9.65603 12.9085 8.39024 12.9085H3.70732C2.53342 12.9085 1.82979 12.5071 1.40543 11.9979C0.961765 11.4655 0.75 10.7255 0.75 9.95122V3.70732C0.75 2.44153 1.00147 1.76456 1.38301 1.38301C1.76456 1.00147 2.44153 0.75 3.70732 0.75Z",
      stroke: "currentColor",
      "stroke-width": "1.5"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M7.21976 6.34479C8.03014 6.34479 8.68708 5.68785 8.68708 4.87747C8.68708 4.0671 8.03014 3.41016 7.21976 3.41016C6.40938 3.41016 5.75244 4.0671 5.75244 4.87747C5.75244 5.68785 6.40938 6.34479 7.21976 6.34479Z",
      fill: "currentColor"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M13.6712 10.4795L13.6684 10.4775L12.8476 9.90073V3.75854L13.6676 3.18235C13.6677 3.18227 13.6678 3.18219 13.668 3.18211C14.021 2.93474 14.2801 2.87809 14.4413 2.87174C14.6067 2.86523 14.7268 2.9096 14.7996 2.94693C14.8665 2.98117 14.9706 3.05164 15.0602 3.19079C15.1476 3.3265 15.2501 3.57203 15.2501 4.00427V9.66281C15.2501 10.095 15.1476 10.3406 15.0602 10.4763C14.9706 10.6154 14.8665 10.6859 14.7996 10.7202L14.7996 10.7201L14.7922 10.724C14.7375 10.7528 14.6301 10.7938 14.4781 10.7938C14.3158 10.7938 14.0436 10.7437 13.6712 10.4795Z",
      stroke: "currentColor",
      "stroke-width": "1.5"
    })
  ])
], -1 /* HOISTED */))
const _hoisted_140 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "14",
    height: "11",
    viewBox: "0 0 14 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M8.71533 1L13 5.28471L8.71533 9.56941",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-miterlimit": "10",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M1 5.28473H12.88",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-miterlimit": "10",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1 /* HOISTED */))
const _hoisted_141 = {
  key: 1,
  class: "live-area lightblue-bg pt-95"
}
const _hoisted_142 = { class: "testimonial-area lightblue-bg pb-85" }
const _hoisted_143 = { class: "container" }
const _hoisted_144 = { class: "row justify-content-center" }
const _hoisted_145 = { class: "col-xxl-6 col-lg-8" }
const _hoisted_146 = { class: "tp-testimonial-section" }
const _hoisted_147 = { class: "tp-section text-center mb-40" }
const _hoisted_148 = { class: "tp-section-3-subtitle" }
const _hoisted_149 = ["innerHTML"]
const _hoisted_150 = ["innerHTML"]
const _hoisted_151 = { style: {"direction":"ltr"} }
const _hoisted_152 = { class: "row justify-content-center" }
const _hoisted_153 = { class: "col-xl-5 col-lg-6 col-md-8" }
const _hoisted_154 = { class: "tp-testimonial-2-avatar-active" }
const _hoisted_155 = ["src"]
const _hoisted_156 = { class: "row justify-content-center" }
const _hoisted_157 = { class: "col-lg-8" }
const _hoisted_158 = { class: "tp-testimonial-2-active" }
const _hoisted_159 = { class: "tp-testimonial-2-avatar-info" }
const _hoisted_160 = { class: "tp-testimonial-2-avatar-title" }
const _hoisted_161 = { class: "tp-testimonial-2-avatar-rating" }
const _hoisted_162 = { class: "course-star-rating d-inline-block mt-2" }
const _hoisted_163 = /*#__PURE__*/_createStaticVNode("<div class=\"back-stars\" data-v-a8f04f4f><i class=\"fa fa-star\" data-v-a8f04f4f></i><i class=\"fa fa-star\" data-v-a8f04f4f></i><i class=\"fa fa-star\" data-v-a8f04f4f></i><i class=\"fa fa-star\" data-v-a8f04f4f></i><i class=\"fa fa-star\" data-v-a8f04f4f></i></div>", 1)
const _hoisted_164 = /*#__PURE__*/_createStaticVNode("<i class=\"fa fa-star\" data-v-a8f04f4f></i><i class=\"fa fa-star\" data-v-a8f04f4f></i><i class=\"fa fa-star\" data-v-a8f04f4f></i><i class=\"fa fa-star\" data-v-a8f04f4f></i><i class=\"fa fa-star\" data-v-a8f04f4f></i>", 5)
const _hoisted_169 = [
  _hoisted_164
]
const _hoisted_170 = { class: "tp-testimonial-2-content p-relative" }
const _hoisted_171 = { key: 0 }
const _hoisted_172 = { key: 1 }
const _hoisted_173 = ["onClick"]
const _hoisted_174 = /*#__PURE__*/_createStaticVNode("<div class=\"tp-testimonial-2-shape\" data-v-a8f04f4f><div class=\"shape-1\" data-v-a8f04f4f><img src=\"/assets/lms_website/website-assets/img/testimonial/testimonial-shape-1.png\" alt=\"\" data-v-a8f04f4f></div><div class=\"shape-2\" data-v-a8f04f4f><img src=\"/assets/lms_website/website-assets/img/testimonial/testimonial-shape-3.png\" alt=\"\" data-v-a8f04f4f></div></div>", 1)
const _hoisted_175 = { class: "team-area pt-100 mb-100" }
const _hoisted_176 = { class: "container" }
const _hoisted_177 = { class: "row align-items-end" }
const _hoisted_178 = { class: "col-lg-6 col-md-8" }
const _hoisted_179 = { class: "tp-section mb-45" }
const _hoisted_180 = { class: "tp-section-3-subtitle" }
const _hoisted_181 = ["innerHTML"]
const _hoisted_182 = ["innerHTML"]
const _hoisted_183 = /*#__PURE__*/_createStaticVNode("<div class=\"col-lg-6 col-md-4\" data-v-a8f04f4f><div class=\"tp-team-2-arrow d-flex align-items-center justify-content-md-end mb-55\" data-v-a8f04f4f><div class=\"tp-team-2-prev\" data-v-a8f04f4f><span data-v-a8f04f4f><svg width=\"7\" height=\"12\" viewBox=\"0 0 7 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-a8f04f4f><path d=\"M6 11L1 6L6 1\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-a8f04f4f></path></svg></span></div><div class=\"tp-team-2-next\" data-v-a8f04f4f><span data-v-a8f04f4f><svg width=\"7\" height=\"12\" viewBox=\"0 0 7 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-a8f04f4f><path d=\"M1 11L6 6L1 1\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-a8f04f4f></path></svg></span></div></div></div>", 1)
const _hoisted_184 = {
  class: "swiper tp-team-2-active wow fadeInUp",
  "data-wow-delay": ".5s"
}
const _hoisted_185 = { class: "swiper-wrapper align-items-end" }
const _hoisted_186 = { class: "tp-team-2-item" }
const _hoisted_187 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tp-team-2-bg geyser" }, null, -1 /* HOISTED */))
const _hoisted_188 = { class: "tp-team-2-thumb" }
const _hoisted_189 = ["src", "alt"]
const _hoisted_190 = { class: "tp-team-2-content" }
const _hoisted_191 = { class: "tp-team-2-title" }
const _hoisted_192 = /*#__PURE__*/_createStaticVNode("<section class=\"banner-area pb-60\" style=\"display:none;\" data-v-a8f04f4f><div class=\"container\" data-v-a8f04f4f><div class=\"row\" data-v-a8f04f4f><div class=\"col-lg-6\" data-v-a8f04f4f><div class=\"tp-banner-sm-2-wrap mb-60 wow fadeInUp\" data-wow-delay=\".3s\" data-v-a8f04f4f><h3 class=\"tp-banner-sm-2-title\" data-v-a8f04f4f> Earn a <br data-v-a8f04f4f><span data-v-a8f04f4f> Certificate <img class=\"tp-underline-shape-11 wow bounceIn\" data-wow-duration=\"1.5s\" data-wow-delay=\".4s\" src=\"/assets/lms_website/website-assets/img/unlerline/banner-2-svg-1.svg\" alt=\"\" data-v-a8f04f4f></span></h3><div class=\"tp-banner-sm-2-btn\" data-v-a8f04f4f><a href=\"contact.html\" data-v-a8f04f4f>View Programs</a></div><div class=\"tp-banner-sm-2-shape-1\" data-v-a8f04f4f><img src=\"/assets/lms_website/website-assets/img/banner/banner-2-thumb-1.png\" alt=\"\" data-v-a8f04f4f></div></div></div><div class=\"col-lg-6\" data-v-a8f04f4f><div class=\"tp-banner-sm-2-wrap tp-banner-sm-2-bg-2 mb-60 wow fadeInUp\" data-wow-delay=\".3s\" data-v-a8f04f4f><h3 class=\"tp-banner-sm-2-title\" data-v-a8f04f4f> Best <br data-v-a8f04f4f> Rated <span data-v-a8f04f4f> Courses <img class=\"tp-underline-shape-11 wow bounceIn\" data-wow-duration=\"1.5s\" data-wow-delay=\".4s\" src=\"/assets/lms_website/website-assets/img/unlerline/banner-2-svg-2.svg\" alt=\"\" data-v-a8f04f4f></span></h3><div class=\"tp-banner-sm-2-btn\" data-v-a8f04f4f><a href=\"course-with-filter.html\" data-v-a8f04f4f>View Programs</a></div><div class=\"tp-banner-sm-2-shape-1\" data-v-a8f04f4f><img src=\"/assets/lms_website/website-assets/img/banner/banner-2-thumb-2.png\" alt=\"\" data-v-a8f04f4f></div></div></div></div></div></section>", 1)
const _hoisted_193 = { class: "cta-area tp-cta-2-bg" }
const _hoisted_194 = { class: "container" }
const _hoisted_195 = { class: "row justify-content-center" }
const _hoisted_196 = { class: "col-xxl-8 col-lg-10" }
const _hoisted_197 = { class: "tp-cta-2-wrapper text-center" }
const _hoisted_198 = ["innerHTML"]
const _hoisted_199 = { class: "tp-cta-2-form" }
const _hoisted_200 = { action: "#" }
const _hoisted_201 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "14",
    height: "12",
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M2.2 1.01465H11.8C12.46 1.01465 13 1.55465 13 2.21465V9.41465C13 10.0746 12.46 10.6146 11.8 10.6146H2.2C1.54 10.6146 1 10.0746 1 9.41465V2.21465C1 1.55465 1.54 1.01465 2.2 1.01465Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M13 2.21436L7 6.41436L1 2.21436",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1 /* HOISTED */))
const _hoisted_202 = ["placeholder"]
const _hoisted_203 = { class: "tp-cta-2-btn" }
const _hoisted_204 = { class: "tp-btn-round" }
const _hoisted_205 = { class: "tp-cta-2-info-list" }
const _hoisted_206 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "14",
    height: "11",
    viewBox: "0 0 14 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      opacity: "0.6",
      d: "M13 1.01465L4.75 9.26465L1 5.51465",
      stroke: "white",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1 /* HOISTED */))
const _hoisted_207 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "14",
    height: "11",
    viewBox: "0 0 14 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      opacity: "0.6",
      d: "M13 1.01465L4.75 9.26465L1 5.51465",
      stroke: "white",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1 /* HOISTED */))
const _hoisted_208 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "14",
    height: "11",
    viewBox: "0 0 14 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      opacity: "0.6",
      d: "M13 1.01465L4.75 9.26465L1 5.51465",
      stroke: "white",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1 /* HOISTED */))

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CourseWidget = _resolveComponent("CourseWidget")
  const _component_router_link = _resolveComponent("router-link")
  const _component_Slide = _resolveComponent("Slide")
  const _component_Carousel = _resolveComponent("Carousel")

  return (_openBlock(), _createElementBlock("main", null, [
    _createCommentVNode(" hero-area-start "),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("span", _hoisted_7, _toDisplayString(($setup.lms_website.settings_list?.sub_ttitle) ? $setup.lms_website.__($setup.lms_website.settings_list?.sub_ttitle) : $setup.lms_website.__('Keep Learning')), 1 /* TEXT */),
                ($setup.lms_website.settings_list?.ttitle)
                  ? (_openBlock(), _createElementBlock("h2", {
                      key: 0,
                      class: "tp-hero-2-title wow fadeInUp",
                      "data-wow-delay": ".5s",
                      innerHTML: $setup.highlightTextWord($setup.lms_website.__($setup.lms_website.settings_list?.ttitle))
                    }, null, 8 /* PROPS */, _hoisted_8))
                  : _createCommentVNode("v-if", true),
                (!$setup.lms_website.settings_list?.ttitle)
                  ? (_openBlock(), _createElementBlock("h2", {
                      key: 1,
                      class: "tp-hero-2-title wow fadeInUp",
                      "data-wow-delay": ".5s",
                      innerHTML: $setup.highlightTextWord($setup.lms_website.__('Best digital [Online] Courses'))
                    }, null, 8 /* PROPS */, _hoisted_9))
                  : _createCommentVNode("v-if", true),
                ($setup.lms_website.settings_list?.description)
                  ? (_openBlock(), _createElementBlock("p", {
                      key: 2,
                      class: "wow fadeInUp",
                      "data-wow-delay": ".7s",
                      innerHTML: $setup.formatTextWithNewLines($setup.lms_website.__($setup.lms_website.settings_list?.description))
                    }, null, 8 /* PROPS */, _hoisted_10))
                  : _createCommentVNode("v-if", true),
                (!$setup.lms_website.settings_list?.description)
                  ? (_openBlock(), _createElementBlock("p", {
                      key: 3,
                      class: "wow fadeInUp",
                      "data-wow-delay": ".7s",
                      innerHTML: $setup.formatTextWithNewLines($setup.lms_website.__('Acquire global knowledge and build your \n professional skills'))
                    }, null, 8 /* PROPS */, _hoisted_11))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("a", {
                    class: "tp-btn-border",
                    href: $setup.lms_website.settings_list?.find_courses_link
                  }, [
                    _createTextVNode(_toDisplayString($setup.lms_website.__('Find Courses')) + " ", 1 /* TEXT */),
                    _hoisted_14
                  ], 8 /* PROPS */, _hoisted_13)
                ])
              ])
            ]),
            ($data.header_course && $data.header_course?.name)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(_component_CourseWidget, { course: $data.header_course }, null, 8 /* PROPS */, ["course"])
                  ])
                ]))
              : _createCommentVNode("v-if", true)
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("img", {
              src: ($setup.lms_website.settings_list.background_photo)?$setup.lms_website.settings_list.background_photo:'/assets/lms_website/website-assets/img/hero/hero-2-thumb-1.png',
              alt: ""
            }, null, 8 /* PROPS */, _hoisted_18)
          ])
        ])
      ]),
      _hoisted_19
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.partner_logos, (partner) => {
            return (_openBlock(), _createElementBlock("div", {
              tooltip: partner.name
            }, [
              _createElementVNode("img", {
                src: partner.logo,
                alt: partner.name
              }, null, 8 /* PROPS */, _hoisted_24)
            ], 8 /* PROPS */, _hoisted_23))
          }), 256 /* UNKEYED_FRAGMENT */))
        ])
      ])
    ]),
    _createCommentVNode(" hero-area-end "),
    _createCommentVNode(" category-area-start "),
    _createElementVNode("section", _hoisted_25, [
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("h5", _hoisted_30, _toDisplayString(($setup.lms_website.settings_list?.categories_section_subtitle) ? $setup.lms_website.__($setup.lms_website.settings_list?.categories_section_subtitle) : $setup.lms_website.__('Top Categories')), 1 /* TEXT */),
              ($setup.lms_website.settings_list?.categories_section_title)
                ? (_openBlock(), _createElementBlock("h3", {
                    key: 0,
                    class: "tp-section-3-title",
                    innerHTML: $setup.highlightSectionTextWord($setup.lms_website.__($setup.lms_website.settings_list?.categories_section_title))
                  }, null, 8 /* PROPS */, _hoisted_31))
                : _createCommentVNode("v-if", true),
              (!$setup.lms_website.settings_list?.categories_section_title)
                ? (_openBlock(), _createElementBlock("h3", {
                    key: 1,
                    class: "tp-section-3-title",
                    innerHTML: $setup.highlightSectionTextWord($setup.lms_website.__('Most demanding [Categories].'))
                  }, null, 8 /* PROPS */, _hoisted_32))
                : _createCommentVNode("v-if", true)
            ])
          ])
        ]),
        ($data.home_categories.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.range(1, 4), (number) => {
                return (_openBlock(), _createElementBlock("div", _hoisted_34, _hoisted_36))
              }), 256 /* UNKEYED_FRAGMENT */))
            ]))
          : _createCommentVNode("v-if", true),
        (!$data.home_categories.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.home_categories.list, (category, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: category.name,
                  class: "col-lg-3 col-md-4 col-sm-6"
                }, [
                  _createVNode(_component_router_link, {
                    to: `/courses/category/${$options.encode_param(category.name)}`,
                    class: "tp-category-item mb-25 wow fadeInUp",
                    "data-wow-delay": `.${((index+1))}s`
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_38, [
                        _createElementVNode("span", {
                          class: _normalizeClass($data.home_categories.colors[category.color])
                        }, [
                          _createElementVNode("img", {
                            src: (category.icon)?category.icon:'',
                            alt: ""
                          }, null, 8 /* PROPS */, _hoisted_39)
                        ], 2 /* CLASS */)
                      ]),
                      _createElementVNode("div", _hoisted_40, [
                        _createElementVNode("h4", _hoisted_41, _toDisplayString($setup.lms_website.__(category.category_name)), 1 /* TEXT */),
                        _createElementVNode("span", null, _toDisplayString($setup.lms_website.__(category.description)), 1 /* TEXT */)
                      ])
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to", "data-wow-delay"])
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ]))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_42, [
          _createElementVNode("div", _hoisted_43, [
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("div", _hoisted_45, [
                _hoisted_46,
                _createElementVNode("div", _hoisted_47, [
                  _createElementVNode("span", null, _toDisplayString($setup.lms_website.__('Let Us Help')), 1 /* TEXT */),
                  _createElementVNode("h4", _hoisted_48, _toDisplayString($setup.lms_website.__('Finding Your Right Courses')), 1 /* TEXT */)
                ])
              ]),
              _createElementVNode("div", _hoisted_49, [
                _createElementVNode("a", _hoisted_50, _toDisplayString($setup.lms_website.__('Get Started')), 1 /* TEXT */)
              ])
            ])
          ])
        ])
      ])
    ]),
    _createCommentVNode(" category-area-end "),
    _createCommentVNode(" funfact-area-start "),
    _createElementVNode("section", _hoisted_51, [
      _createElementVNode("div", _hoisted_52, [
        _createElementVNode("div", _hoisted_53, [
          _createElementVNode("div", _hoisted_54, [
            _createElementVNode("div", _hoisted_55, [
              _hoisted_56,
              _createElementVNode("div", _hoisted_57, [
                _createElementVNode("h4", _hoisted_58, _toDisplayString($setup.lms_website.__('Flexible classes')), 1 /* TEXT */),
                _createElementVNode("span", null, _toDisplayString($setup.lms_website.__('You pick schedule.')), 1 /* TEXT */)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_59, [
            _createElementVNode("div", _hoisted_60, [
              _hoisted_61,
              _createElementVNode("div", _hoisted_62, [
                _createElementVNode("h4", _hoisted_63, _toDisplayString($setup.lms_website.__('Offline mode')), 1 /* TEXT */),
                _createElementVNode("span", null, _toDisplayString($setup.lms_website.__('Download classes.')), 1 /* TEXT */)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_64, [
            _createElementVNode("div", _hoisted_65, [
              _hoisted_66,
              _createElementVNode("div", _hoisted_67, [
                _createElementVNode("h4", _hoisted_68, _toDisplayString($setup.lms_website.__('10k online courses')), 1 /* TEXT */),
                _createElementVNode("span", null, _toDisplayString($setup.lms_website.__('Explore a fresh topics')), 1 /* TEXT */)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_69, [
            _createElementVNode("div", _hoisted_70, [
              _hoisted_71,
              _createElementVNode("div", _hoisted_72, [
                _createElementVNode("h4", _hoisted_73, _toDisplayString($setup.lms_website.__('Educator help')), 1 /* TEXT */),
                _createElementVNode("span", null, _toDisplayString($setup.lms_website.__('Always get answers.')), 1 /* TEXT */)
              ])
            ])
          ])
        ])
      ])
    ]),
    _createCommentVNode(" funfact-area-end "),
    _createCommentVNode(" course-area-start "),
    _createElementVNode("section", _hoisted_74, [
      _createElementVNode("div", _hoisted_75, [
        _createElementVNode("div", _hoisted_76, [
          _createElementVNode("div", _hoisted_77, [
            _createElementVNode("div", _hoisted_78, [
              _createElementVNode("h5", _hoisted_79, _toDisplayString(($setup.lms_website.settings_list?.our_courses_section_subtitle) ? $setup.lms_website.__($setup.lms_website.settings_list?.our_courses_section_subtitle) : $setup.lms_website.__('Our Courses')), 1 /* TEXT */),
              ($setup.lms_website.settings_list?.our_courses_section_title)
                ? (_openBlock(), _createElementBlock("h3", {
                    key: 0,
                    class: "tp-section-3-title",
                    innerHTML: $setup.highlightSectionTextWord($setup.lms_website.__($setup.lms_website.settings_list?.our_courses_section_title))
                  }, null, 8 /* PROPS */, _hoisted_80))
                : _createCommentVNode("v-if", true),
              (!$setup.lms_website.settings_list?.our_courses_section_title)
                ? (_openBlock(), _createElementBlock("h3", {
                    key: 1,
                    class: "tp-section-3-title",
                    innerHTML: $setup.highlightSectionTextWord($setup.lms_website.__('Our [Courses]'))
                  }, null, 8 /* PROPS */, _hoisted_81))
                : _createCommentVNode("v-if", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_82, [
            _createElementVNode("div", _hoisted_83, [
              _createElementVNode("div", _hoisted_84, [
                _createElementVNode("span", {
                  class: "pointer-event",
                  onClick: _cache[0] || (_cache[0] = (...args) => ($options.homeCoursesCarouselPrev && $options.homeCoursesCarouselPrev(...args)))
                }, _hoisted_86)
              ]),
              _createElementVNode("div", _hoisted_87, [
                _createElementVNode("span", {
                  class: "pointer-event",
                  onClick: _cache[1] || (_cache[1] = (...args) => ($options.homeCoursesCarouselNext && $options.homeCoursesCarouselNext(...args)))
                }, _hoisted_89)
              ])
            ])
          ])
        ]),
        (!$data.our_courses.loading)
          ? (_openBlock(), _createBlock(_component_Carousel, _mergeProps({ key: 0 }, $data.our_courses.settings, {
              breakpoints: $data.our_courses.breakpoints,
              ref: "homeCoursesCarousel"
            }), {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.our_courses.list, (course) => {
                  return (_openBlock(), _createBlock(_component_Slide, {
                    class: "animate__animated animate__zoomIn",
                    key: course.name
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CourseWidget, {
                        course: course,
                        "css-class": "text-left",
                        "css-style": "width:100%;margin:0 12px;"
                      }, null, 8 /* PROPS */, ["course"])
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1024 /* DYNAMIC_SLOTS */))
                }), 128 /* KEYED_FRAGMENT */))
              ]),
              _: 1 /* STABLE */
            }, 16 /* FULL_PROPS */, ["breakpoints"]))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_90, [
          ($data.our_courses.loading)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($options.range(1, 3), (number) => {
                return (_openBlock(), _createElementBlock("div", _hoisted_91, _hoisted_93))
              }), 256 /* UNKEYED_FRAGMENT */))
            : _createCommentVNode("v-if", true)
        ]),
        _createElementVNode("div", _hoisted_94, [
          _createElementVNode("div", _hoisted_95, [
            _createVNode(_component_router_link, {
              to: "/courses",
              class: "btn btn-lg btn-outline-secondary w-100"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString($setup.lms_website.__('View All')), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            })
          ])
        ])
      ])
    ]),
    _createCommentVNode(" course-area-end "),
    _createCommentVNode(" live-area-start "),
    ($data.live_course?.name)
      ? (_openBlock(), _createElementBlock("section", _hoisted_96, [
          _createElementVNode("div", _hoisted_97, [
            _createElementVNode("div", _hoisted_98, [
              _createElementVNode("div", _hoisted_99, [
                _createElementVNode("div", _hoisted_100, [
                  _createElementVNode("h5", _hoisted_101, _toDisplayString(($setup.lms_website.settings_list?.live_course_sectionsub_title) ? $setup.lms_website.__($setup.lms_website.settings_list?.live_course_sectionsub_title) : $setup.lms_website.__('Live Courses')), 1 /* TEXT */),
                  ($setup.lms_website.settings_list?.live_course_section_title)
                    ? (_openBlock(), _createElementBlock("h3", {
                        key: 0,
                        class: "tp-section-3-title",
                        innerHTML: $setup.highlightSectionTextWord($setup.lms_website.__($setup.lms_website.settings_list?.live_course_section_title))
                      }, null, 8 /* PROPS */, _hoisted_102))
                    : _createCommentVNode("v-if", true),
                  (!$setup.lms_website.settings_list?.live_course_section_title)
                    ? (_openBlock(), _createElementBlock("h3", {
                        key: 1,
                        class: "tp-section-3-title",
                        innerHTML: $setup.highlightSectionTextWord($setup.lms_website.__('Top [free] live Courses'))
                      }, null, 8 /* PROPS */, _hoisted_103))
                    : _createCommentVNode("v-if", true)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_104, [
              _createElementVNode("div", _hoisted_105, [
                _createElementVNode("div", _hoisted_106, [
                  _createElementVNode("div", _hoisted_107, [
                    _createElementVNode("div", _hoisted_108, [
                      _createElementVNode("div", _hoisted_109, [
                        _createElementVNode("img", {
                          src: ($data.live_course?.image)?$data.live_course?.image:'/assets/lms_website/images/placeholder.jpg',
                          style: {"width":"440px","max-height":"310px"},
                          alt: $data.live_course?.title
                        }, null, 8 /* PROPS */, _hoisted_110),
                        _hoisted_111,
                        _createElementVNode("div", _hoisted_112, [
                          _createElementVNode("span", null, [
                            _hoisted_113,
                            _createTextVNode(" " + _toDisplayString($options.courseDuration($data.live_course?.custom_course_duration)), 1 /* TEXT */)
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_114, [
                      _createElementVNode("div", _hoisted_115, [
                        _createElementVNode("span", _hoisted_116, _toDisplayString($data.live_course?.tags), 1 /* TEXT */),
                        _createElementVNode("div", _hoisted_117, [
                          _createElementVNode("div", _hoisted_118, [
                            _createElementVNode("div", _hoisted_119, [
                              _createElementVNode("img", {
                                src: ($data.live_course?.instructor?.user_image)?$data.live_course?.instructor?.user_image:'/assets/lms_website/images/user.png',
                                alt: ""
                              }, null, 8 /* PROPS */, _hoisted_120)
                            ]),
                            _createElementVNode("div", _hoisted_121, [
                              _createElementVNode("span", null, _toDisplayString($setup.lms_website.__('Teacher')), 1 /* TEXT */),
                              _createElementVNode("h4", _hoisted_122, _toDisplayString($data.live_course?.instructor?.full_name), 1 /* TEXT */)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_123, [
                            _createElementVNode("p", null, [
                              _createTextVNode(_toDisplayString($options.floatVale($data.live_course?.avg_rating)) + " ", 1 /* TEXT */),
                              _hoisted_124
                            ]),
                            _createElementVNode("div", _hoisted_125, [
                              _createElementVNode("div", _hoisted_126, [
                                _hoisted_127,
                                _createElementVNode("div", {
                                  class: "front-stars",
                                  style: _normalizeStyle('width:'+$options.avg_rating_width($data.live_course?.avg_rating))
                                }, _hoisted_133, 4 /* STYLE */)
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("h4", _hoisted_134, [
                          _createVNode(_component_router_link, {
                            to: `/courses/view/${$data.live_course?.name}`
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString($options.clip($data.live_course?.title, 65)), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                          }, 8 /* PROPS */, ["to"])
                        ]),
                        _createElementVNode("div", _hoisted_135, [
                          _createElementVNode("div", _hoisted_136, [
                            _createElementVNode("span", null, _toDisplayString($setup.lms_website.__('Live Students')), 1 /* TEXT */),
                            _hoisted_137
                          ]),
                          ($data.live_course?.name)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_138, [
                                _createVNode(_component_router_link, {
                                  class: "tp-btn-border",
                                  to: `/courses/view/${$data.live_course?.name}`
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_139,
                                    _createTextVNode(" " + _toDisplayString($setup.lms_website.__('Join Now')) + " ", 1 /* TEXT */),
                                    _hoisted_140
                                  ]),
                                  _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["to"])
                              ]))
                            : _createCommentVNode("v-if", true)
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true),
    (!$data.live_course?.name)
      ? (_openBlock(), _createElementBlock("section", _hoisted_141))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" live-area-end "),
    _createCommentVNode(" testimonial-area-start "),
    _createElementVNode("section", _hoisted_142, [
      _createElementVNode("div", _hoisted_143, [
        _createElementVNode("div", _hoisted_144, [
          _createElementVNode("div", _hoisted_145, [
            _createElementVNode("div", _hoisted_146, [
              _createElementVNode("div", _hoisted_147, [
                _createElementVNode("h5", _hoisted_148, _toDisplayString(($setup.lms_website.settings_list?.student_reviews_section_subtitle) ? $setup.lms_website.__($setup.lms_website.settings_list?.student_reviews_section_subtitle) : $setup.lms_website.__('Courses Reviews')), 1 /* TEXT */),
                ($setup.lms_website.settings_list?.student_reviews_section_title)
                  ? (_openBlock(), _createElementBlock("h3", {
                      key: 0,
                      class: "tp-section-3-title",
                      innerHTML: $setup.highlightSectionTextWord($setup.lms_website.__($setup.lms_website.settings_list?.student_reviews_section_title))
                    }, null, 8 /* PROPS */, _hoisted_149))
                  : _createCommentVNode("v-if", true),
                (!$setup.lms_website.settings_list?.student_reviews_section_title)
                  ? (_openBlock(), _createElementBlock("h3", {
                      key: 1,
                      class: "tp-section-3-title",
                      innerHTML: $setup.highlightSectionTextWord($setup.lms_website.__('Student Say About [UNIX]'))
                    }, null, 8 /* PROPS */, _hoisted_150))
                  : _createCommentVNode("v-if", true)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_151, [
          _createElementVNode("div", _hoisted_152, [
            _createElementVNode("div", _hoisted_153, [
              _createElementVNode("div", _hoisted_154, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.home_reviews.list, (review) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: review.name,
                    class: "tp-testimonial-2-avatar-item"
                  }, [
                    _createElementVNode("img", {
                      src: (review?.user_data?.user_image)?review?.user_data?.user_image:'/assets/lms_website/images/user.png',
                      alt: "avatar"
                    }, null, 8 /* PROPS */, _hoisted_155)
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_156, [
            _createElementVNode("div", _hoisted_157, [
              _createElementVNode("div", _hoisted_158, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.home_reviews.list, (review) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: review.name,
                    class: "tp-testimonial-2-item text-center"
                  }, [
                    _createElementVNode("div", _hoisted_159, [
                      _createElementVNode("h4", _hoisted_160, _toDisplayString(review?.user_data?.full_name), 1 /* TEXT */),
                      _createElementVNode("span", null, _toDisplayString($options.clip(review?.course?.title, 50)), 1 /* TEXT */),
                      _createElementVNode("div", _hoisted_161, [
                        _createElementVNode("div", _hoisted_162, [
                          _hoisted_163,
                          _createElementVNode("div", {
                            class: "front-stars",
                            style: _normalizeStyle('width:'+$options.avg_rating_width(review.rating))
                          }, _hoisted_169, 4 /* STYLE */)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_170, [
                      (!review.expanded)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_171, _toDisplayString($options.clip(review?.review, 100)), 1 /* TEXT */))
                        : (_openBlock(), _createElementBlock("p", _hoisted_172, _toDisplayString(review?.review), 1 /* TEXT */)),
                      (review?.review && review?.review.length > 100)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 2,
                            onClick: $event => (review.expanded = !review.expanded),
                            class: "tp-btn-read-more"
                          }, _toDisplayString(review.expanded ? $setup.lms_website.__('Show Less') : $setup.lms_website.__('Read More')), 9 /* TEXT, PROPS */, _hoisted_173))
                        : _createCommentVNode("v-if", true),
                      _hoisted_174
                    ])
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ])
          ])
        ])
      ])
    ]),
    _createCommentVNode(" testimonial-area-end "),
    _createCommentVNode(" team-area-start "),
    _createElementVNode("section", _hoisted_175, [
      _createElementVNode("div", _hoisted_176, [
        _createElementVNode("div", _hoisted_177, [
          _createElementVNode("div", _hoisted_178, [
            _createElementVNode("div", _hoisted_179, [
              _createElementVNode("h5", _hoisted_180, _toDisplayString(($setup.lms_website.settings_list?.instructors_section_subtitle) ? $setup.lms_website.__($setup.lms_website.settings_list?.instructors_section_subtitle) : $setup.lms_website.__('Our Team')), 1 /* TEXT */),
              ($setup.lms_website.settings_list?.instructors_section_title)
                ? (_openBlock(), _createElementBlock("h3", {
                    key: 0,
                    class: "tp-section-3-title",
                    innerHTML: $setup.highlightSectionTextWord($setup.lms_website.__($setup.lms_website.settings_list?.instructors_section_title))
                  }, null, 8 /* PROPS */, _hoisted_181))
                : _createCommentVNode("v-if", true),
              (!$setup.lms_website.settings_list?.instructors_section_title)
                ? (_openBlock(), _createElementBlock("h3", {
                    key: 1,
                    class: "tp-section-3-title",
                    innerHTML: $setup.highlightSectionTextWord($setup.lms_website.__('Meet Our [Teachers]'))
                  }, null, 8 /* PROPS */, _hoisted_182))
                : _createCommentVNode("v-if", true)
            ])
          ]),
          _hoisted_183
        ]),
        _createElementVNode("div", _hoisted_184, [
          _createElementVNode("div", _hoisted_185, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.home_instructors.list, (instructor) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "swiper-slide",
                key: instructor.name
              }, [
                _createElementVNode("div", _hoisted_186, [
                  _hoisted_187,
                  _createElementVNode("div", _hoisted_188, [
                    _createElementVNode("img", {
                      src: (instructor.photo)?instructor.photo:'/assets/lms_website/images/avatar-character.png',
                      alt: instructor.instructor_name
                    }, null, 8 /* PROPS */, _hoisted_189)
                  ]),
                  _createElementVNode("div", _hoisted_190, [
                    _createElementVNode("h4", _hoisted_191, [
                      _createElementVNode("a", null, _toDisplayString(instructor.instructor_name), 1 /* TEXT */)
                    ]),
                    _createElementVNode("span", null, _toDisplayString(instructor.instructor_title), 1 /* TEXT */)
                  ])
                ])
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ])
      ])
    ]),
    _createCommentVNode(" team-area-end "),
    _createCommentVNode(" bannner-area-start "),
    _hoisted_192,
    _createCommentVNode(" bannner-area-end "),
    _createCommentVNode(" cta-area-start "),
    _createElementVNode("section", _hoisted_193, [
      _createElementVNode("div", _hoisted_194, [
        _createElementVNode("div", _hoisted_195, [
          _createElementVNode("div", _hoisted_196, [
            _createElementVNode("div", _hoisted_197, [
              _createElementVNode("h2", {
                class: "tp-cta-2-title",
                innerHTML: ($setup.lms_website.settings_list?.newsletter_section_title)?$setup.highlightSectionTextWord($setup.lms_website.__($setup.lms_website.settings_list?.newsletter_section_title)):$setup.highlightSectionTextWord($setup.lms_website.__('Get Started With [UNIX] Now'))
              }, null, 8 /* PROPS */, _hoisted_198),
              _createElementVNode("p", null, _toDisplayString(($setup.lms_website.settings_list?.newsletter_section_subtitle) ? $setup.lms_website.__($setup.lms_website.settings_list?.newsletter_section_subtitle) : $setup.lms_website.__('Enter your email and stay with us on activities.')), 1 /* TEXT */),
              _createElementVNode("div", _hoisted_199, [
                _createElementVNode("form", _hoisted_200, [
                  _hoisted_201,
                  _createElementVNode("input", {
                    type: "text",
                    placeholder: $setup.lms_website.__('Enter your email')
                  }, null, 8 /* PROPS */, _hoisted_202),
                  _createElementVNode("div", _hoisted_203, [
                    _createElementVNode("button", _hoisted_204, _toDisplayString($setup.lms_website.__('Subscribe!')), 1 /* TEXT */)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_205, [
                _createElementVNode("span", null, [
                  _hoisted_206,
                  _createTextVNode(" " + _toDisplayString($setup.lms_website.__('Easy to Access')), 1 /* TEXT */)
                ]),
                _createElementVNode("span", null, [
                  _hoisted_207,
                  _createTextVNode(" " + _toDisplayString($setup.lms_website.__('No Credit card')), 1 /* TEXT */)
                ]),
                _createElementVNode("span", null, [
                  _hoisted_208,
                  _createTextVNode(" " + _toDisplayString($setup.lms_website.__('85,000 student onboard with us')), 1 /* TEXT */)
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createCommentVNode(" cta-area-end ")
  ]))
}